module.exports = __webpack_public_path__ + "img/24-l.d2b6d954.png";